import * as React from "react";

import { Header, Navigation, Filter, Footer } from "../../shared";
import { TableAnalytical } from './TableAnalytical';
import "./VejaPanel.scss";

import {
    Grid
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { BestsellingProductFilter, BestsellingProviderFilter } from "src/component/panel";
import { BestsellingFilterChip } from "src/component/panel/shared/chips/BestsellingFilterChip";
import { CurrentDate, SomeDaysAgo } from "src/services";

// tslint:disable-next-line:no-empty-interface
export interface IVejaPanelProps {}

// tslint:disable-next-line:no-empty-interface
export interface IVejaPanelState {
    endDate: any,
    initialDate: any,
}

export class VejaPanel extends React.Component<IVejaPanelProps, IVejaPanelState> {

    private productFilter: React.RefObject<BestsellingProductFilter>;
    private providerFilter: React.RefObject<BestsellingProviderFilter>;

    constructor(props: IVejaPanelProps) {
        super(props);
        this.productFilter = React.createRef();
        this.providerFilter = React.createRef();
        this.state = {
            endDate: undefined,
            initialDate: undefined,
        }
        this.changeDate = this.changeDate.bind(this);
        this.setFilterState = this.setFilterState.bind(this);
    }

    public componentWillMount () {
        const finalDate = CurrentDate();
        const initDate = SomeDaysAgo(7);
        this.changeDate(initDate, finalDate);
    }

    public render() {
        const filters = [
            <BestsellingProviderFilter key={1} ref={this.providerFilter} initialDate={this.state.initialDate} endDate={this.state.endDate}  filterType={1} />,
            <BestsellingProductFilter key={2} ref={this.productFilter} initialDate={this.state.initialDate} endDate={this.state.endDate}  filterType={1} />,
        ];
        return (
            <div>
                <Header title={"Mais vendidos Veja"} name={"Mais vendidos Veja"} link={"/dashboard"} />
                <Navigation
                    name={"Mais vendidos Veja"}
                    linkDefault={"/panel/veja"}
                    link={"/dashboard"}
                    linkTitle={"Produtos"}
                    painel={3}
                    icon={<ChevronRightIcon />}
                />

                <Filter filters={filters} />
                <BestsellingFilterChip initialDate={this.state.initialDate} endDate={this.state.endDate} filterType={1} />

                <div className="wrapper">
                    <Grid
                        container={true}
                        className="veja-panel panel-grid"
                        spacing={16}
                    >
                        <Grid item={true} xs={12} >
                            <TableAnalytical  initialDate={this.state.initialDate} endDate={this.state.endDate} changeDate={this.changeDate}  />
                        </Grid>
                    </Grid>
                </div>
                <Footer />
            </div>
        );
    }

    public changeDate (init: any, end: any) {
        this.setState({
            endDate: end,
            initialDate: init,
        });
        this.setFilterState(init, end);
    }

    public setFilterState (init: any, end: any) {
        if(this.productFilter != null && this.productFilter.current != null) {
            this.productFilter.current.changeDate(init, end);
        }

        if(this.providerFilter != null && this.providerFilter.current != null) {
            this.providerFilter.current.changeDate(init, end);
        }
    }
}


// WEBPACK FOOTER //
// ./src/component/panel/veja/VejaPanel.tsx